import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import LoadingComponent from '../common/LoadingComponent';

class Auth extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let code = urlParams.get('code');
        if (!code && window.location.hash) {
            const hashParams = new URLSearchParams(window.location.hash.substring(1));
            code = hashParams.get('code');
        }
        if (code) {
            let fromUrl = null;
        if (this.props.location.state && this.props.location.state.from) {
            fromUrl = this.props.location.state.from.pathname;
        }
            dispatch.login.googleLoginAsync({ idToken: code, fromUrl });
        }
    }
    render() {
        return (
            <div>
                <LoadingComponent active={true} message="Logging in" />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: (state.loading.effects.login.loginAsync || state.loading.effects.login.googleLoginAsync) && state.loading.models.login,
        loginError: state.login.loginError,
        emailId: state.login.emailId,
        version: state.login.version,
    };
}

const connectedAuthPage = connect(mapStateToProps)(Auth);

export { connectedAuthPage as Auth }; 